(function ($) {
  window.agro_components = window.agro_components || {};

  function attachComponents(context) {
    const $ctx = $(context);
    for (const key of Object.keys(window.agro_components)) {
      window.agro_components[key].attach($ctx);
    }
  }

  $(function () {
    attachComponents(document);
  })

  $(document.body).on('ajax_content_loaded', function (e) {
    attachComponents(e.target);
  });

  $.fn.triggerAjaxLoaded = function (options) {
    $(this).trigger('ajax_content_loaded', [options]);
  };
})(jQuery);
